<template>
    <div class="all">
      <Head></Head>
      <div class="bannerShop">
        <div class="bannerShop_img">
        <!--  <img src="../assets/zhanshi.png" alt="">
          <img src="../assets/zhanshi01.png" alt="">-->
          <img :src="classData.sing.photo?$store.state.Url+classData.sing.photo:img" alt="" style="height: 400px">
          <div class="clear"></div>
        </div>
      </div>
      <div class="bannerShop">
        <div class="bannerShop_image">
<!--          <img src="../assets/tejia.png" alt="">-->
<!--          <p class="bannerShop_image_p1">———— {{item.name}} ————</p>-->
          <div class="bannerShop_for_shop">
            <div class="bannerShop_for_shop_Shop" v-for="(val,index) in classData.goods" :key="index">
              <div class="bannerShop_for_shop_Shop_img">
                <img :src="$store.state.Url+val.goods_img" alt="" @click="getxiangqing(val.goods_id)">
              </div>
              <div class="bannerShop_for_shop_Shop_title" @click="getxiangqing(val.goods_id)">
                {{val.goods_name}}
              </div>
              <div class="bannerShop_for_shop_Shop_bo">
                <p>{{val.price}}</p>
                <button @click="getAddShopIng(val.goods_id)">加入购物车</button>
                <div class="clear"></div>
              </div>
            </div>
            <div class="clear"></div>
          </div>
        </div>
      </div>
      <Pagetail></Pagetail>
    </div>
</template>

<script>
  import Pagetail from '../assembly/Pagetail'
  import Head from '../assembly/Head'
  import {getclass_tive1,gettice_index} from '../api/index'
  import img from '../assets/zanwu.png'
  import {getshopping} from "../api/List";
    export default {
        name: "bannerShop",
      components: {
        Pagetail, Head
      },
      data(){
          return{
            LsitData:{},
            img:img,
            classData:{},
            tejia:[],
            classKey:''
          }
      },
      mounted() {
        this.init()
      },
      methods:{
          init(){
            getclass_tive1({
              id:this.$route.query.id
            }).then(res=>{
              this.classData = res
            })
          },
        init1(id){
          gettice_index({
                          class_id:id
                        }).then(res=>{
            this.LsitData = res
          })
        },
        getKey(key){
            if (this.classKey == key){
              this.classKey = 10000
            }else {
              this.classKey = key
            }
        },
        getAddShopIng(id){
          if (this.$store.state.user.token){
            getshopping({goods_id:id,num:1}).then(res=>{
              this.$router.push({path:'/ShoppingCart'})
            })
          }else {
            this.$router.push({path:'/login'})
          }
        },
        getxiangqing(id){
          console.log(id)
          this.$router.push({path:'/details',query:{id:id,status:2}})
        },
      }
    }
</script>

<style scoped lang="less">
  @import "css/bannerShop1";
</style>



// WEBPACK FOOTER //
// src/components/bannerShop1.vue